var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTouchCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(-102 -1257.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    transform: "translate(102 1257.244)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-touch-app",
    "data-name": "Icon material-touch-app",
    d: "M10.363,10.778V7.929a1.9,1.9,0,0,1,3.81,0v2.85a3.429,3.429,0,1,0-3.81,0Zm7.5,3.528L14.4,12.584a1.073,1.073,0,0,0-.411-.084h-.579V7.929a1.143,1.143,0,0,0-2.286,0v8.183l-2.613-.549a1.332,1.332,0,0,0-.183-.023.852.852,0,0,0-.6.251l-.6.61,3.764,3.764a1.147,1.147,0,0,0,.808.335H16.87a1.11,1.11,0,0,0,1.1-.975l.571-4.015a1.1,1.1,0,0,0-.678-1.2Z",
    transform: "translate(99.875 1256.744)",
    fill: "#050505"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouchCircle);
export default __webpack_public_path__ + "static/media/touch-circle.b471503d4c7418691ca7533ae47a7e83.svg";
export { ForwardRef as ReactComponent };